import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import WaitingSearch from "../../components/doctor/waiting_search";
import WaitingPatientTest from "../../components/doctor/waiting_patient_tests";

function Waiting() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState(true);
  const [Id, setId] = useState(null);
  const [name, setName] = useState("");

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        {search && (
          <WaitingSearch
            setLoader={setLoader}
            setSearch={setSearch}
            search={search}
            setId={setId}
            setName={setName}
          />
        )}
        {!search && (
          <WaitingPatientTest
            setLoader={setLoader}
            setSearch={setSearch}
            id={Id}
            name={name}
          />
        )}
      </div>
    </div>
  );
}

export default Waiting;
